module.exports = __webpack_public_path__ + "static/27-3e4fbea23334af493be1fff1165cc767.png";